import React from "react";
import { EyebrowText } from "../../atoms/EyebrowText";
import "./styles.css";

/**
 * Sección "¿Cómo funciona?" para la home.
 * Cuatro pasos del proceso con números circulares + título + descripción,
 * conectados por una línea decorativa horizontal en desktop.
 */
export const HowItWorks = () => {
  const steps = [
    {
      n: "1",
      title: "Simula tu crédito",
      desc: "Calcula tu cuota en segundos sin compromiso.",
    },
    {
      n: "2",
      title: "Solicita el préstamo",
      desc: "Llena un formulario simple con tus datos.",
    },
    {
      n: "3",
      title: "Aprobamos en 24h",
      desc: "Te confirmamos el resultado por WhatsApp.",
    },
    {
      n: "4",
      title: "Recibe tu moto",
      desc: "Estrenas y disfrutas del camino.",
    },
  ];

  return (
    <section className="how-it-works" aria-labelledby="hiw-title">
      <div className="how-it-works__inner">
        <EyebrowText className="how-it-works__eyebrow">
          ¿Cómo funciona?
        </EyebrowText>
        <h2 id="hiw-title" className="how-it-works__heading">
          En 4 pasos tienes tu moto
        </h2>

        <ol className="how-it-works__steps">
          {steps.map((step) => (
            <li key={step.n} className="how-it-works__step">
              <span className="how-it-works__number" aria-hidden="true">
                {step.n}
              </span>
              <h3 className="how-it-works__step-title">{step.title}</h3>
              <p className="how-it-works__step-desc">{step.desc}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
